import type { WidgetDataContract } from "@nexus/widget-sdk";

/**
 * `protection-overview-event-cdn-thieves` v1 — the CDN-theft infrastructure
 * providers abused to serve stolen content, for one published protected-event
 * report edition.
 */
export const EVENT_CDN_THIEVES_CONTRACT: WidgetDataContract = {
  name: "protection-overview-event-cdn-thieves",
  version: 1,
};

export interface EventCdnThief {
  id: string;
  label: string;
  distinctIps: number;
  countries: number;
  accounts: number;
  channels: number;
  /** Fraction of the event during which the thief's CDN was made unavailable, 0-1. */
  cdnUnavailPct: number;
  /** Total CDN-unavailability duration in minutes. */
  unavailDurationMin: number;
}

export interface EventCdnThievesFreshness {
  generatedAt: string;
  dataThrough: string;
  source: string;
  isEstimated: boolean;
}

export interface EventCdnThievesData {
  thieves: EventCdnThief[];
  freshness: EventCdnThievesFreshness;
}
